import React from 'react';
import { Logo } from '@/assets/logo';

interface InvalidLinkProps {
  message?: string;
}

export function InvalidLink({ message = 'هذا الرابط غير صالح أو منتهي الصلاحية.' }: InvalidLinkProps) {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <Logo className="h-12 w-12 text-secondary mb-4" />
      <h1 className="text-xl font-semibold text-primary-dark mb-2">رابط غير صالح</h1>
      <p className="text-gray-600">{message}</p>
    </div>
  );
}